import { useEffect, useState } from 'react';

const NAV_ITEMS = [
  { id: 'rexian', label: '实锤快讯', icon: 'ri-flashlight-line' },
  { id: 'qidi', label: '人物起底', icon: 'ri-focus-2-line' },
  { id: 'shichui', label: '事件扒皮', icon: 'ri-file-search-line' },
  { id: 'dangan', label: '分类档案', icon: 'ri-folder-shield-2-line' },
  { id: 'tuolu', label: '围观热度', icon: 'ri-fire-line' },
  { id: 'zhengji', label: '线索征集', icon: 'ri-megaphone-line' },
];

export default function Masthead() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const jump = (id: string) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header className="sticky top-0 z-50 bg-[#f6f1e8]/95 backdrop-blur border-b border-[#e0d6c6]">
      {/* 顶部细条 */}
      <div className="bg-[#262019] text-[#f0e8d8]">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-1.5 text-[11px] md:px-6">
          <p className="flex items-center gap-1.5">
            <span className="live-dot inline-block h-1.5 w-1.5 rounded-full bg-[#e04b35]"></span>
            <span className="tracking-wide">24 小时不间断线索复核中 · 今日新增 128 条</span>
          </p>
          <div className="hidden items-center gap-4 sm:flex">
            <span className="flex items-center gap-1 text-[#d8cbb6]">
              <i className="ri-community-line"></i> 阅读公约
            </span>
            <span className="flex items-center gap-1 text-[#d8cbb6]">
              <i className="ri-error-warning-line"></i> 勘误申请
            </span>
          </div>
        </div>
      </div>

      {/* 报头 / 杂志头 */}
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 md:flex-row md:px-6 md:py-6">
        <a href="#top" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="group flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#262019] text-[#f5efe3]">
            <i className="ri-fire-fill text-2xl text-[#e8603c]"></i>
          </span>
          <span className="leading-none">
            <span className="font-display block text-3xl font-black tracking-tight text-[#262019] md:text-[42px]">
              51黑料<span className="ml-1 align-top text-sm font-bold text-[#c83424]">深挖 · 起底 · 实锤</span>
            </span>
            <span className="mt-1 hidden text-[11px] tracking-[0.35em] text-[#8a7a67] sm:block">
              内幕真相档案室 · EVERY CLUE COUNTS
            </span>
          </span>
        </a>

        <div className="flex w-full items-center justify-between gap-3 md:w-auto md:justify-end">
          <p className="hidden items-center gap-2 text-xs text-[#6b5f51] lg:flex">
            <i className="ri-calendar-2-line text-[#c83424]"></i>
            <span className="font-medium">2026 年 9 月 6 日</span>
            <span className="mx-1 text-[#c9bdab]">|</span>
            <span>已归档专题 36 个</span>
          </p>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="flex h-10 items-center gap-2 rounded-md border border-[#d8cbb6] bg-white px-3 text-sm text-[#262019] md:hidden"
            aria-label="打开菜单"
          >
            <i className={menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}></i>
            栏目
          </button>
          <button
            onClick={() => document.getElementById('zhengji')?.scrollIntoView({ behavior: 'smooth' })}
            className="hidden whitespace-nowrap rounded-md bg-[#c83424] px-4 py-2.5 text-sm font-semibold text-white hover:bg-[#a9281c] sm:flex"
          >
            <i className="ri-megaphone-line mr-1.5"></i>我要投稿线索
          </button>
        </div>
      </div>

      {/* 导航 */}
      <nav className="hidden border-t border-[#e0d6c6] md:block">
        <div className="mx-auto flex max-w-7xl items-center gap-1 px-6">
          {NAV_ITEMS.map((n) => (
            <button
              key={n.id}
              onClick={() => jump(n.id)}
              className="group flex cursor-pointer items-center gap-1.5 px-3 py-3 text-sm font-medium text-[#4a4037] hover:text-[#c83424]"
            >
              <i className={`${n.icon} text-base text-[#9a8a75] group-hover:text-[#c83424]`}></i>
              {n.label}
            </button>
          ))}
          <div className="ml-auto flex items-center gap-2 pl-4">
            <div className="flex items-center gap-2 rounded-md border border-[#d8cbb6] bg-white px-3 py-1.5">
              <i className="ri-search-line text-[#9a8a75]"></i>
              <input
                placeholder="搜人物 / 事件 / 关键词"
                className="w-44 bg-transparent text-sm outline-none placeholder:text-[#b3a58f]"
              />
              <i className="ri-command-line text-[#c9bdab]"></i>
            </div>
          </div>
        </div>
      </nav>

      {/* 移动端菜单 */}
      {menuOpen && (
        <div className="border-t border-[#e0d6c6] bg-[#faf6ee] px-4 py-3 md:hidden">
          <div className="mb-3 flex items-center gap-2 rounded-md border border-[#d8cbb6] bg-white px-3 py-2">
            <i className="ri-search-line text-[#9a8a75]"></i>
            <input placeholder="搜人物 / 事件 / 关键词" className="w-full bg-transparent text-sm outline-none" />
          </div>
          <div className="grid grid-cols-2 gap-2">
            {NAV_ITEMS.map((n) => (
              <button
                key={n.id}
                onClick={() => jump(n.id)}
                className="flex cursor-pointer items-center gap-2 rounded-md border border-[#e0d6c6] bg-white px-3 py-2.5 text-sm text-[#4a4037]"
              >
                <i className={`${n.icon} text-[#c83424]`}></i>
                {n.label}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* 面包屑栏 */}
      <div className="hidden border-t border-[#eadfd0] bg-[#f0e8d8]/60 px-6 py-1.5 md:block">
        <div className="mx-auto flex max-w-7xl items-center gap-2 text-[11px] text-[#8a7a67]">
          <i className="ri-home-4-line"></i>
          <span>首页</span>
          <i className="ri-arrow-right-s-line"></i>
          <span className="font-medium text-[#4a4037]">深挖 · 起底 · 实锤总览</span>
          <span className="mx-2 inline-block h-3 w-px bg-[#c9bdab]"></span>
          <span className="flex items-center gap-1">
            <i className="ri-verified-badge-line text-[#c83424]"></i>本站内容均已人工核对信源
          </span>
        </div>
      </div>
    </header>
  );
}